import { apiRequest } from '@/lib/api/client'

import { DEFAULT_JASTIP_FEE_CONFIG, jastipFeeResponseSchema, type JastipFeeConfig } from './schema'
import { fromWire, toWire } from './wire'

const CONFIGURATION_PATH = '/v1/algo-pos-be/liotitip/configuration'

/**
 * GET the signed-in Jastiper's fee config (WEBLP-3210). The BE returns Custom Rp0
 * when nothing is saved; an unusable stored shape also falls back to that default.
 */
export async function fetchJastipFeeConfig(signal?: AbortSignal): Promise<JastipFeeConfig> {
  const payload = await apiRequest(CONFIGURATION_PATH, {
    schema: jastipFeeResponseSchema,
    signal,
  })
  return fromWire(payload.jastip_fee) ?? DEFAULT_JASTIP_FEE_CONFIG
}

/** PUT (create or replace) the fee config and return the BE-normalized result (WEBLP-3209). */
export async function saveJastipFeeConfig(config: JastipFeeConfig): Promise<JastipFeeConfig> {
  const payload = await apiRequest(CONFIGURATION_PATH, {
    method: 'PUT',
    body: { jastip_fee: toWire(config) },
    schema: jastipFeeResponseSchema,
  })
  return fromWire(payload.jastip_fee) ?? config
}
